export default {
  meta: {
    title: '分析报告',
  },
};
